module.exports = __webpack_public_path__ + "ef5fda45cbbbd1b0fb29d6d2dafd91bb.png";